import Tooltip from 'bootstrap/js/dist/tooltip';

const showTooltip = (event) => {
  const element = event.target.closest?.('[data-bs-toggle="tooltip"]');
  if (!element) return;
  if (Tooltip.getInstance(element)) return;

  Tooltip.getOrCreateInstance(element).show();
};

export const enableDynamicTooltips = () => {
  document.addEventListener('mouseover', showTooltip);
  document.addEventListener('focusin', showTooltip);
};
